import axios from 'axios'

import Settings from "../../settings.json";

const url = Settings.isNative ? Settings.frontlineArServer : "";

export class ProcedureRequester {

    static async getAllProcedures(projectId, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/${projectId}/GetAllProcedures`);
        return result.data
    }

    static async getFolderLevel(projectId, db, {nestedRoute, parentId, parentType, skip = 0, limit = 100, search = '', published = false, includePublishedRoles = false, sortBy} = {}) {
        const queryParams = new URLSearchParams();
        if (nestedRoute) queryParams.set('nestedRoute', nestedRoute);
        if (parentId) queryParams.set('parentId', parentId);
        if (parentType) queryParams.set('parentType', parentType);
        queryParams.set('skip', String(skip));
        queryParams.set('limit', String(limit));
        if (search) queryParams.set('search', search);
        queryParams.set('published', String(published));
        queryParams.set('includePublishedRoles', String(includePublishedRoles));
        if (sortBy) queryParams.set('sortBy', sortBy);
        const result = await axios.get(`${url}/ProcedureManagment/${db}/${projectId}/GetFolderLevel?${queryParams.toString()}`);
        return result.data;
    }

    static async changeLanguageVisibility(procedureId, workspace, langKey) {
        const result = await axios.put(`${url}/ProcedureManagment/${workspace}/change-language-visibility`, {procedureId, langKey});
        return result.data;
    }

    static async setShortUrl(fullUrl, {db, itemType, itemId}) {
        const result = await axios.post(`${url}/ProcedureManagment/short-url/set`, {
            fullUrl,
            db,
            itemType,
            itemId,
        });
        return result.data;
    }

    static async getFullUrl(id) {
        const result = await axios.get(`${url}/ProcedureManagment/short-url/get/${id}`);
        return result.data
    }

    static async getAllPublishedProcedures(projectId, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/${projectId}/GetAllPublishProcedures`);
        return result.data
    }

    static async getProcedure(id, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/get-procedure-by/${id}`);
        return result.data
    }

    static async getProcedureUploadStatus(id, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/get-procedure-upload-status/${id}`);
        return result.data
    }

    static async getPublishedProcedure(id, db) {
        const result = await axios.get(`${url}/ProcedureManagment/published/${db}/${id}`);
        return result.data
    }

    static async getProcedureSession(db, id) {
        const result = await axios.get(`${url}/ProcedureSessions/${db}/${id}/GetProcedureSession`);
        return result.data
    }

    static async getPayPerClickSession(db, procedureRef, payPerClickId) {
        const result = await axios.post(`${url}/ProcedureSessions/${db}/${procedureRef}/GetPayPerClickSession`, {
            payPerClickId
        });
        return result.data
    }

    static async updateSession(session, workspace) {
        await axios.put(`${url}/ProcedureSessions/${workspace}/UpdateProcedureSession`, session)
    }

    static async createOrUpdateProcedure(procedure, db) {
        const response = await axios.put(`${url}/ProcedureManagment/${db}/UpdateProcedure`, procedure);
        return response.data;
    }

    static exitEditorBeacon(procedure, db) {
        const blob = new Blob([JSON.stringify(procedure)], { type: 'application/json' });
        navigator.sendBeacon(`${url}/ProcedureManagment/${db}/ExitEditor`, blob);
    }

    static async getAppChanges(procedureId, db) {
        const response = await axios.get(`${url}/ProcedureManagment/${db}/GetNewAppNodesUpdates/${procedureId}`);
        return response.data;
    }

    static async deleteProcedure(id, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/${id}/delete-procedure`);
        return result.status >= 200 && result.status < 300;
    }

    static async unPublishProcedure(procedureId, db) {
        const result = await axios.put(`${url}/ProcedureManagment/unPublish/${db}/${procedureId}`);
        return result.data
    }

    static async sendSitePrepPublishRequest(procedureId, db) {
        const result = await axios.put(`${url}/ProcedureManagment/send-site-prep-publish-request/${db}/${procedureId}`);
        return result.data
    }

    static async publishProcedure(procedureId, versionObj, db, payPerClick) {
        const result = await axios.put(`${url}/ProcedureManagment/publish/${db}/${procedureId}`, {
            versionObj,
            payPerClick
        });
        return result.data
    }

    static async getAllViews(id, db) {
        const result = await axios.get(`${url}/ProcedureSessions/${db}/${id}/getProcedureViews`);
        return result.data.views
    }

    static async getSessions(id, db) {
        const result = await axios.get(`${url}/ProcedureSessions/${db}/${id}/GetSingleProcedureSessions`);
        return result.data
    }

    static async getAllPublishedProceduresByProjectsIds(projectsIds, db) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/GetAllPublishedByIds`, projectsIds);
        return result.data
    }

    static async translateNode(nodeData, languages, defaultLanguage, isSkipText, workspace, projectId){
        const result = await axios.post(`${url}/AI/${workspace}/translate`, {
            nodeData,
            languages,
            defaultLanguage,
            isSkipText,
            projectId
        });
        return result.data
    }

    static async generateAIInstructions(data, workspace, projectId) {
        const result = await axios.post(`${url}/AI/${workspace}/${projectId}/AIInstructions`, {data});
        return result.data
    }

    static async deleteProcedureLanguage(workspace, procedureId, langKey){
        const result = await axios.post(`${url}/ProcedureManagment/${workspace}/delete-procedure-language`,{procedureId, langKey});
        return result.data;
}

    static async getProcedureVersions(procedureId, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/${procedureId}/GetProcedureVersions`);
        return result.data
    }

    static async getProcedureVersionDetail(procedureId, versionNumber, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/${procedureId}/GetProcedureVersionDetail/${versionNumber}`);
        return result.data
    }

    static async getEditingVersions(procedureId, db) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/get-current-editing-versions/${procedureId}`);
        return result.data
    }

    static async editReleaseNotes(procedureId, versionObj, db) {
        const result = await axios.put(`${url}/ProcedureManagment/${db}/${procedureId}/EditReleaseNotes`, versionObj);
        return result.data
    }

    static async rollback(procedureId, versionObj, db) {
        const result = await axios.put(`${url}/ProcedureManagment/${db}/${procedureId}/Rollback`, versionObj);
        return result.data
    }

    static async rollbackEditingVersion(procedureId, editVersionNumber, currentEditIdentifier, workspace) {
        const result = await axios.put(`${url}/ProcedureManagment/${workspace}/rollback-editing-version/${procedureId}`, {
            editVersionNumber,
            currentEditIdentifier
        });
        return result.data
    }

    static async duplicateProcedure(importedFromWorkspace, procedureId, currentProjectId, db) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/duplicate-procedure`, {
            importedFromWorkspace, procedureId, currentProjectId
        });
        return result.data
    }


    static async updateMirroredPermittedRoles(procedureId, permittedRoles, db) {
        const result = await axios.put(`${url}/ProcedureManagment/${db}/${procedureId}/UpdateMirroredPermittedRoles`, {permittedRoles});
        return result.data;
    }

    static async startStreamSession(deeplink, workspace, procedureId) {
        const result = await axios.post(`${url}/ProcedureManagment/start-stream-session/`, {
            deeplink, workspace, procedureId
        });
        return result.data
    }

    static async endStreamSession(streamId) {
        const result = await axios.post(`${url}/ProcedureManagment/end-stream-session/`, {
            streamId
        });
        return result.data
    }

    static async getPayPerClickStatus(db, procedureId) {
        const result = await axios.get(`${url}/ProcedureManagment/pay-per-click-status/${db}/${procedureId}`);
        return result.data
    }

    static async getPayPerClick(db, payPerClickId) {
        const result = await axios.get(`${url}/ProcedureManagment/pay-per-click/${db}/${payPerClickId}`);
        return result.data
    }

    static async deletePendingPayPerClick(db, payPerClickId) {
        await axios.delete(`${url}/ProcedureManagment/pending-pay-per-click/${db}/${payPerClickId}`)
    }

    static async updatePayPerClick(db, payPerClick) {
        const result = await axios.put(`${url}/ProcedureManagment/update-pay-per-click/${db}`, payPerClick);
        return result.data
    }

    static async updateMultipleConnections(modelId, markedProcedures, workspace) {
        const result = await axios.post(`${url}/ProcedureManagment/${workspace}/update-multiple-connections`, {
            modelId, markedProcedures
        });
        return result.data
    }

    static async getUserDefinedInteractions(workspace, projectRef, procedureIds, includeFakeFolders = false) {
        const result = await axios.post(`${url}/InteractiveIOManagment/${workspace}/${projectRef}/user-defined-interactions`, {
            procedureIds,
            includeFakeFolders
        });
        return result.data
    }

    static async deleteInteraction(workspace, interactionId, procedureId) {
        const result = await axios.delete(`${url}/InteractiveIOManagment/${workspace}/${interactionId}/${procedureId}/delete-user-defined-interaction`);
        return result.data
    }

    static async getAttached3dItems(workspace, twoDProcedureId, threeDIds, isPublished) {
        const result = await axios.post(`${url}/ProjectManagment/${workspace}/get-attached-3d-items/`, {
            twoDProcedureId, threeDIds, isPublished
        });
        return result.data
    }

    static async getFlowEditorStatus(workspace, procedureId) {
        const result = await axios.get(`${url}/ProcedureManagment/${workspace}/get-flow-editor-status/${procedureId}`);
        return result.data
    }

    static async updateFlowEditorStatus(workspace, procedureId, currentEditIdentifier, editingVersionNumber) {
        const result = await axios.put(`${url}/ProcedureManagment/${workspace}/update-flow-editor-status/${procedureId}`, {
            currentEditIdentifier, editingVersionNumber
        });
        return result.data
    }

    static async checkIfTooManyProcedureActiveEditors(procedureId, workspace) {
        if (!procedureId) return false;
        const result = await axios.get(`${url}/ProcedureManagment/${workspace}/check-too-many-procedure-active-editors/${procedureId}`);
        return result.data
    }

    static async getTtsToken(procedureId, workspace) {
        const result = await axios.get(`${url}/ProcedureManagment/${workspace}/get-tts-token/${procedureId}`);
        return result.data

    }

    static async upsertInteraction(workspace, interactionJson) {
        const result = await axios.post(`${url}/InteractiveIOManagment/${workspace}/update-user-defined-interaction`, interactionJson);
        return result.data
    }

    static async duplicateAnimation(workspace, interactiveStepId, procedureId) {
        const result = await axios.post(`${url}/InteractiveIOManagment/${workspace}/${procedureId}/duplicate-user-defined-interaction-folder`,{interactiveStepId});
        return result.data
    }

    static async updateFolderPaths(workspace, currentFolderPath, destinationFolderPath, projectId, procedureId) {
        console.log(procedureId);
        const result = await axios.post(`${url}/InteractiveIOManagment/${workspace}/update-interaction-folder-paths`, {
            currentFolderPath,
            destinationFolderPath,
            projectId,
            procedureId
        });
        return result.data
    }

    static async deleteInteractionFolder(workspace, folderPath, projectId, procedureId) {
        const result = await axios.post(`${url}/InteractiveIOManagment/${workspace}/delete-interaction-folder`, {
            folderPath,
            projectId,
            procedureId
        });
        return result.data
    }

    static async getFavoriteProcedures(workspace) {
        const result = await axios.get(`${url}/ProcedureManagment/${workspace}/favorite-items/get`);
        return result.data
    }

    static async addFavoriteProcedure(workspace, currentProjectId, itemId) {
        const result = await axios.post(`${url}/ProcedureManagment/${workspace}/favorite-items/add`, {
            currentProjectId,
            itemId
        });
        return result.data
    }

    static async removeFavoriteProcedure(workspace, itemId) {
        const result = await axios.delete(`${url}/ProcedureManagment/${workspace}/favorite-items/${itemId}/remove`, {
            itemId
        });
        return result.data
    }

    static async getUsedFileInProcedure(db ,ids) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/check-is-file-used-in-procedure`,
            {filesIds : ids});
        return result.data
    }

    static async saveGuidesFile(db, savedFiles, projectId, folderId) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/save-guides-file`,
            {
                savedFiles,
                projectId,
                folderId
            });
        return result.data
    }

    static async getInitConvertGuideData(db, projectId) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/get-guide-init-process-value`,
            {
                projectId
            });
        return result.data
    }
    static async getUpdatedProgress(db, files, projectId) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/get-guides-file-updates`,
            {
                files,
                projectId,
            });
        return result.data
    }
    static async cancelConvertGuideProcess(db, fileIds, isCancelAllBatch, projectId) {
        const result = await axios.post(`${url}/ProcedureManagment/${db}/cancel-convert-guide-file`,
            {
                fileIds,
                isCancelAllBatch,
                projectId,
            });
        return result.data
    }

    static async getRemoteAssets(db, assetsGuids, token) {
        const result = await axios.post(`${url}/remote-assets/${db}/get-remote-assets/`, {
            assetsGuids,
            token
        });
        return result.data;
    }
    static async getProcedureUsages(db, interactiveStepID, projectId) {
        const result = await axios.get(`${url}/ProcedureManagment/${db}/get-animation-usages/${projectId}/${interactiveStepID}`);
        return result.data;
    }
}
